import { FormConfig, createFormFromConfig } from './GenericFormTemplate';

// ============================================
// CONFIGURAÇÕES DOS FORMULÁRIOS CRIMINAIS/PENAIS
// ============================================

// Habeas Corpus
export const HABEAS_CORPUS_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Habeas Corpus',
  description: 'Ação constitucional para proteger a liberdade de locomoção contra ilegalidade ou abuso de poder',
  suggestedDocs: 'Auto de prisão, Decisão de custódia e documentos comprobatórios da ilegalidade.',
  infoTip: 'No habeas corpus, demonstre claramente a ilegalidade ou abuso de poder que constrange a liberdade do paciente.',
};
export const HabeasCorpusForm = createFormFromConfig(HABEAS_CORPUS_CONFIG);

// Queixa-Crime
export const QUEIXA_CRIME_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Queixa-Crime',
  description: 'Peça inicial da ação penal privada para crimes de ação privada',
  suggestedDocs: 'Provas do crime, documentos de identificação das partes e comprovantes.',
  infoTip: 'Na queixa-crime, descreva detalhadamente o fato criminoso, qualificando autor e vítima, e indique as provas.',
};
export const QueixaCrimeForm = createFormFromConfig(QUEIXA_CRIME_CONFIG);

// Defesa Prévia Criminal
export const DEFESA_PREVIA_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Defesa Prévia Criminal',
  description: 'Defesa preliminar do acusado antes do recebimento da denúncia ou queixa',
  suggestedDocs: 'Auto de prisão, Denúncia, Inquérito policial, Processo na íntegra e Queixa-crime.',
  defaultPecaRebater: 'Denúncia',
  pecaRebaterHelper: 'Indique a denúncia ou queixa-crime que deseja rebater',
  infoTip: 'Na defesa prévia, apresente argumentos para rejeição da denúncia ou absolvição sumária do acusado.',
};
export const DefesaPreviaCriminalForm = createFormFromConfig(DEFESA_PREVIA_CRIMINAL_CONFIG);

// Resposta à Acusação
export const RESPOSTA_ACUSACAO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Resposta à Acusação',
  description: 'Defesa do acusado após o recebimento da denúncia ou queixa',
  suggestedDocs: 'Denúncia, Processo na íntegra e Queixa-crime.',
  defaultPecaRebater: 'Denúncia, Queixa-Crime',
  pecaRebaterHelper: 'Indique a denúncia ou queixa-crime recebida',
  infoTip: 'Na resposta à acusação, argua preliminares, questões prejudiciais e requeira absolvição sumária se cabível.',
};
export const RespostaAcusacaoForm = createFormFromConfig(RESPOSTA_ACUSACAO_CONFIG);

// Pedido de Liberdade Provisória
export const PEDIDO_LIBERDADE_PROVISORIA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Liberdade Provisória',
  description: 'Requerimento de liberdade com ou sem fiança para acusado preso',
  suggestedDocs: 'Auto de prisão e Decisão de custódia.',
  defaultPecaRebater: 'Decisão de Custódia',
  pecaRebaterHelper: 'Indique a decisão que decretou ou manteve a prisão',
  infoTip: 'No pedido de liberdade, demonstre a ausência dos requisitos da prisão preventiva e proponha medidas cautelares alternativas.',
};
export const PedidoLiberdadeProvisoriaForm = createFormFromConfig(PEDIDO_LIBERDADE_PROVISORIA_CONFIG);

// Recurso em Sentido Estrito
export const RECURSO_SENTIDO_ESTRITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso em Sentido Estrito',
  description: 'Recurso contra decisões interlocutórias no processo penal',
  suggestedDocs: 'Decisão recorrida e Processo na íntegra.',
  defaultPecaRebater: 'Decisão Interlocutória',
  pecaRebaterHelper: 'Indique a decisão interlocutória que deseja recorrer',
  infoTip: 'No RESE, demonstre o cabimento do recurso (art. 581 do CPP) e as razões para reforma da decisão.',
};
export const RecursoSentidoEstritoForm = createFormFromConfig(RECURSO_SENTIDO_ESTRITO_CONFIG);

// Revisão Criminal
export const REVISAO_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Revisão Criminal',
  description: 'Ação para rever condenação penal transitada em julgado',
  suggestedDocs: 'Processo criminal completo.',
  defaultPecaRebater: 'Processo Original',
  pecaRebaterHelper: 'Indique o processo criminal que será revisado',
  infoTip: 'Na revisão criminal, demonstre a existência de prova nova, erro judiciário ou contrariedade ao texto da lei.',
};
export const RevisaoCriminalForm = createFormFromConfig(REVISAO_CRIMINAL_CONFIG);

// Alegações Finais Criminais
export const ALEGACOES_FINAIS_CRIMINAIS_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Alegações Finais Criminais',
  description: 'Razões finais da defesa ou acusação no processo penal',
  suggestedDocs: 'Denúncia, Peças do processo penal (como Denúncia e Resposta à Acusação) e Processo na íntegra.',
  defaultPecaRebater: 'Processo Inteiro',
  pecaRebaterHelper: 'Refere-se ao processo penal completo',
  infoTip: 'Nas alegações finais, analise todas as provas produzidas e formule pedido de absolvição ou condenação fundamentado.',
};
export const AlegacoesFinaisCriminaisForm = createFormFromConfig(ALEGACOES_FINAIS_CRIMINAIS_CONFIG);

// Apelação Criminal
export const APELACAO_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Apelação Criminal',
  description: 'Recurso contra sentença penal condenatória ou absolutória',
  suggestedDocs: 'Peça de acusação, Peça de defesa, Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Sentença',
  pecaRebaterHelper: 'Indique a sentença que deseja apelar',
  infoTip: 'Na apelação criminal, ataque os fundamentos da sentença e demonstre os erros de fato ou de direito.',
};
export const ApelacaoCriminalForm = createFormFromConfig(APELACAO_CRIMINAL_CONFIG);

// Pedido de Progressão de Regime
export const PEDIDO_PROGRESSAO_REGIME_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Progressão de Regime',
  description: 'Requerimento de progressão de regime prisional do condenado',
  suggestedDocs: 'Atestado de conduta, Cálculo de pena, Processo na íntegra e Sentença condenatória.',
  defaultPecaRebater: 'Sentença Condenatória',
  pecaRebaterHelper: 'Indique a sentença condenatória',
  infoTip: 'No pedido de progressão, demonstre o cumprimento do requisito temporal e do requisito subjetivo (bom comportamento).',
};
export const PedidoProgressaoRegimeForm = createFormFromConfig(PEDIDO_PROGRESSAO_REGIME_CONFIG);

// Pedido de Revogação de Prisão Preventiva
export const REVOGACAO_PRISAO_PREVENTIVA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Revogação de Prisão Preventiva',
  description: 'Requerimento para revogar a prisão preventiva decretada',
  suggestedDocs: 'Ata da audiência de custódia, Auto de prisão em flagrante, Decisão de prisão preventiva e Processo na íntegra.',
  defaultPecaRebater: 'Decisão de Prisão Preventiva',
  pecaRebaterHelper: 'Indique a decisão que decretou a prisão preventiva',
  infoTip: 'Demonstre a cessação dos motivos que ensejaram a prisão ou a possibilidade de aplicação de medidas cautelares diversas.',
};
export const RevogacaoPrisaoPreventivaForm = createFormFromConfig(REVOGACAO_PRISAO_PREVENTIVA_CONFIG);

// Pedido de Revogação de Prisão Preventiva com Medidas Cautelares
export const REVOGACAO_PRISAO_MEDIDAS_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Revogação de Prisão Preventiva e Aplicação de Medidas Cautelares',
  description: 'Requerimento para revogar prisão preventiva com aplicação de medidas cautelares alternativas',
  suggestedDocs: 'Ata da audiência de custódia, Auto de prisão em flagrante, Decisão de prisão preventiva e Processo na íntegra.',
  defaultPecaRebater: '',
  pecaRebaterHelper: 'Ex. Petição inicial feita na data de 21/05/2025',
  infoTip: 'Proponha medidas cautelares adequadas e suficientes para substituir a prisão preventiva.',
};
export const RevogacaoPrisaoMedidasForm = createFormFromConfig(REVOGACAO_PRISAO_MEDIDAS_CONFIG);

// Denúncia
export const DENUNCIA_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Denúncia',
  description: 'Peça acusatória do Ministério Público para iniciar ação penal pública',
  suggestedDocs: 'Inquérito policial, provas documentais e laudos periciais.',
  infoTip: 'Na denúncia, descreva o fato criminoso com todas as circunstâncias, qualifique o acusado e classifique o crime.',
};
export const DenunciaForm = createFormFromConfig(DENUNCIA_CONFIG);

// Emenda à Inicial Criminal
export const EMENDA_INICIAL_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_com_tipo',
  title: 'Emenda à Inicial (Criminal)',
  description: 'Correção ou complementação da denúncia ou queixa-crime',
  suggestedDocs: 'Despacho judicial, Denúncia/Queixa original e documentos complementares.',
  defaultPecaRebater: 'Despacho',
  pecaRebaterHelper: 'Indique o despacho que determinou a emenda',
  infoTip: 'Atenda às determinações do juízo para sanar vícios ou complementar a peça acusatória.',
};
export const EmendaInicialCriminalForm = createFormFromConfig(EMENDA_INICIAL_CRIMINAL_CONFIG);

// Réplica Criminal (Alegações do MP)
export const REPLICA_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Réplica Criminal (Alegações do MP)',
  description: 'Manifestação do Ministério Público em resposta à defesa prévia',
  suggestedDocs: 'Denúncia, Processo na íntegra, Queixa-Crime e Resposta à Acusação.',
  defaultPecaRebater: '',
  pecaRebaterHelper: 'Ex. Petição inicial feita na data de 21/05/2025',
  infoTip: 'Rebata os argumentos da defesa e reforce a acusação com base nas provas dos autos.',
};
export const ReplicaCriminalForm = createFormFromConfig(REPLICA_CRIMINAL_CONFIG);

// Exceção de Suspeição Criminal
export const EXCECAO_SUSPEICAO_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Exceção de Suspeição',
  description: 'Arguição de suspeição do juiz no processo criminal',
  suggestedDocs: 'Decisão atacada, Denúncia, Processo na íntegra e Provas.',
  defaultPecaRebater: 'Processo Inteiro',
  pecaRebaterHelper: 'Indique o processo em que atua o juiz suspeito',
  infoTip: 'Demonstre uma das hipóteses legais de suspeição (art. 254 do CPP) e apresente provas.',
};
export const ExcecaoSuspeicaoCriminalForm = createFormFromConfig(EXCECAO_SUSPEICAO_CRIMINAL_CONFIG);

// Pedido de Relaxamento de Prisão
export const RELAXAMENTO_PRISAO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Relaxamento de Prisão',
  description: 'Requerimento para relaxar prisão ilegal em flagrante ou preventiva',
  suggestedDocs: 'Auto de prisão, Decisão de custódia e Processo na íntegra.',
  defaultPecaRebater: 'Decisão de Custódia',
  pecaRebaterHelper: 'Indique a decisão de custódia que deseja rebater',
  infoTip: 'Demonstre a ilegalidade da prisão (formalidades do flagrante, ausência de fundamentação, etc.).',
};
export const RelaxamentoPrisaoForm = createFormFromConfig(RELAXAMENTO_PRISAO_CONFIG);

// Pedido de Revogação de Medidas Protetivas de Urgência
export const REVOGACAO_MEDIDAS_PROTETIVAS_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Revogação de Medidas Protetivas de Urgência',
  description: 'Requerimento para revogar medidas protetivas da Lei Maria da Penha',
  suggestedDocs: 'Decisão de medidas protetivas.',
  defaultPecaRebater: 'Decisão de Medidas Protetivas',
  pecaRebaterHelper: 'Indique a decisão que deferiu as medidas protetivas',
  infoTip: 'Demonstre a cessação do risco ou a desnecessidade das medidas impostas.',
};
export const RevogacaoMedidasProtetivasForm = createFormFromConfig(REVOGACAO_MEDIDAS_PROTETIVAS_CONFIG);

// Manifestação para Apresentação de Quesitos Periciais Criminal
export const QUESITOS_PERICIAIS_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Manifestação para Apresentação de Quesitos Periciais',
  description: 'Formulação de quesitos para perícia criminal',
  suggestedDocs: 'Despacho que determinou a perícia e Processo na íntegra.',
  defaultPecaRebater: 'Despacho que determina apresentação de quesitos',
  pecaRebaterHelper: 'Indique o despacho que determinou a apresentação de quesitos',
  infoTip: 'Formule quesitos objetivos e relevantes para esclarecer os fatos do processo.',
};
export const QuesitosPericialsCriminalForm = createFormFromConfig(QUESITOS_PERICIAIS_CRIMINAL_CONFIG);

// Manifestação Processual Criminal
export const MANIFESTACAO_PROCESSUAL_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_com_tipo',
  title: 'Manifestação Processual (Criminal)',
  description: 'Manifestação genérica nos autos do processo criminal',
  suggestedDocs: 'Processo na íntegra.',
  defaultPecaRebater: 'Despacho ou Petição',
  pecaRebaterHelper: 'Ex: Petição da acusação feita em 21/05/2025',
  infoTip: 'Manifeste-se sobre o ponto específico determinado pelo juízo ou de interesse da parte.',
};
export const ManifestacaoProcessualCriminalForm = createFormFromConfig(MANIFESTACAO_PROCESSUAL_CRIMINAL_CONFIG);

// Contrarrazões à Apelação Criminal
export const CONTRARRAZOES_APELACAO_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões à Apelação Criminal',
  description: 'Resposta à apelação interposta pela parte contrária no processo penal',
  suggestedDocs: 'Apelação criminal, Sentença e Processo na íntegra.',
  defaultPecaRebater: 'Apelação Criminal',
  pecaRebaterHelper: 'Indique a apelação que deseja contrarrazoar',
  infoTip: 'Defenda a manutenção da sentença, rebatendo os argumentos do apelante.',
};
export const ContrarrazoesApelacaoCriminalForm = createFormFromConfig(CONTRARRAZOES_APELACAO_CRIMINAL_CONFIG);

// Contrarrazões ao Recurso em Sentido Estrito
export const CONTRARRAZOES_RESE_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Recurso em Sentido Estrito',
  description: 'Resposta ao RESE interposto pela parte contrária',
  suggestedDocs: 'Recurso em Sentido Estrito, Decisão recorrida e Processo na íntegra.',
  defaultPecaRebater: 'Recurso em Sentido Estrito',
  pecaRebaterHelper: 'Indique o RESE que deseja contrarrazoar',
  infoTip: 'Defenda a manutenção da decisão interlocutória recorrida.',
};
export const ContrarrazoesRESEForm = createFormFromConfig(CONTRARRAZOES_RESE_CONFIG);

// Recurso Ordinário Constitucional Criminal
export const RECURSO_ORDINARIO_CONSTITUCIONAL_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Ordinário Constitucional (Criminal)',
  description: 'Recurso ao STF/STJ em habeas corpus ou mandado de segurança criminal',
  suggestedDocs: 'Acórdão denegatório, Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Decisão Denegatória',
  pecaRebaterHelper: 'Indique a decisão que denegou a ordem',
  infoTip: 'Demonstre o cabimento do ROC e as razões para reforma da decisão denegatória.',
};
export const RecursoOrdinarioConstitucionalCriminalForm = createFormFromConfig(RECURSO_ORDINARIO_CONSTITUCIONAL_CRIMINAL_CONFIG);

// Memoriais Recursais Criminal
export const MEMORIAIS_RECURSAIS_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Memoriais Recursais (Criminal)',
  description: 'Memoriais para julgamento de recurso criminal',
  suggestedDocs: 'Acórdão, Processo na íntegra, Razões recursais e Sentença.',
  defaultPecaRebater: '',
  pecaRebaterHelper: 'Ex. Petição inicial feita na data de 21/05/2025',
  infoTip: 'Reforce os principais argumentos do recurso e apresente jurisprudência favorável atualizada.',
};
export const MemoriaisRecursaisCriminalForm = createFormFromConfig(MEMORIAIS_RECURSAIS_CRIMINAL_CONFIG);

// Memoriais Recursais para Ministro do STJ Criminal
export const MEMORIAIS_STJ_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Memoriais Recursais para Ministro do STJ (Criminal)',
  description: 'Memoriais direcionados a Ministro do STJ em processo criminal',
  suggestedDocs: 'Acórdão, Decisão impugnada, Processo na íntegra e Razões recursais.',
  defaultPecaRebater: 'Razões Recursais',
  pecaRebaterHelper: 'Indique as razões recursais apresentadas',
  infoTip: 'Destaque a relevância da questão federal e a jurisprudência favorável do próprio STJ.',
};
export const MemoriaisSTJCriminalForm = createFormFromConfig(MEMORIAIS_STJ_CRIMINAL_CONFIG);

// Recurso Especial Criminal
export const RECURSO_ESPECIAL_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Especial (Criminal)',
  description: 'Recurso ao STJ por violação à lei federal em matéria criminal',
  suggestedDocs: 'Acórdão, Embargos de declaração e Processo na íntegra.',
  defaultPecaRebater: 'Acórdão',
  pecaRebaterHelper: 'Indique o acórdão que violou lei federal',
  infoTip: 'Demonstre a violação à lei federal ou a divergência jurisprudencial entre tribunais.',
};
export const RecursoEspecialCriminalForm = createFormFromConfig(RECURSO_ESPECIAL_CRIMINAL_CONFIG);

// Contrarrazões ao Recurso Especial Criminal
export const CONTRARRAZOES_RESP_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Recurso Especial (Criminal)',
  description: 'Resposta ao REsp interposto em processo criminal',
  suggestedDocs: 'Acórdão penal, Processo na íntegra e REsp.',
  defaultPecaRebater: 'Recurso Especial',
  pecaRebaterHelper: 'Indique o recurso especial que deseja contrarrazoar',
  infoTip: 'Demonstre a ausência de violação à lei federal ou a correção do acórdão recorrido.',
};
export const ContrarrazoesRespCriminalForm = createFormFromConfig(CONTRARRAZOES_RESP_CRIMINAL_CONFIG);

// Agravo em Recurso Especial Criminal
export const AGRAVO_RESP_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Agravo em Recurso Especial (Criminal)',
  description: 'Agravo contra decisão que inadmitiu REsp criminal',
  suggestedDocs: 'Acórdão, Decisão de admissibilidade e Processo na íntegra.',
  defaultPecaRebater: 'Despacho Denegatório',
  pecaRebaterHelper: 'Indique a decisão que inadmitiu o recurso especial',
  infoTip: 'Demonstre o equívoco da decisão de inadmissão e o preenchimento dos requisitos do REsp.',
};
export const AgravoRespCriminalForm = createFormFromConfig(AGRAVO_RESP_CRIMINAL_CONFIG);

// Contraminuta ao Agravo em Recurso Especial Criminal
export const CONTRAMINUTA_AGRAVO_RESP_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contraminuta ao Agravo em Recurso Especial (Criminal)',
  description: 'Resposta ao agravo em REsp criminal',
  suggestedDocs: 'Agravo em REsp, Processo na íntegra e REsp.',
  defaultPecaRebater: 'Agravo em Recurso Especial',
  pecaRebaterHelper: 'Indique o agravo que deseja responder',
  infoTip: 'Defenda a decisão de inadmissão do REsp, demonstrando seus vícios.',
};
export const ContraminutaAgravoRespCriminalForm = createFormFromConfig(CONTRAMINUTA_AGRAVO_RESP_CRIMINAL_CONFIG);

// Recurso Extraordinário Criminal
export const RECURSO_EXTRAORDINARIO_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Extraordinário (Criminal)',
  description: 'Recurso ao STF por violação à Constituição em matéria criminal',
  suggestedDocs: 'Acórdão penal, Decisão de admissibilidade e Processo na íntegra.',
  defaultPecaRebater: 'Acórdão',
  pecaRebaterHelper: 'Indique o acórdão que viola a Constituição',
  infoTip: 'Demonstre a violação direta à Constituição e a repercussão geral da matéria.',
};
export const RecursoExtraordinarioCriminalForm = createFormFromConfig(RECURSO_EXTRAORDINARIO_CRIMINAL_CONFIG);

// Contrarrazões ao Recurso Extraordinário Criminal
export const CONTRARRAZOES_RE_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Recurso Extraordinário (Criminal)',
  description: 'Resposta ao RE interposto em processo criminal',
  suggestedDocs: 'Acórdão penal, Processo na íntegra e RE.',
  defaultPecaRebater: 'Recurso Extraordinário',
  pecaRebaterHelper: 'Indique o recurso extraordinário que deseja contrarrazoar',
  infoTip: 'Demonstre a ausência de repercussão geral ou a inexistência de violação direta à Constituição.',
};
export const ContrarrazoesRECriminalForm = createFormFromConfig(CONTRARRAZOES_RE_CRIMINAL_CONFIG);

// Embargos de Declaração Criminal
export const EMBARGOS_DECLARACAO_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Embargos de Declaração (Criminal)',
  description: 'Recurso para sanar omissão, contradição ou obscuridade em decisão penal',
  suggestedDocs: 'Decisão judicial penal e Processo na íntegra.',
  defaultPecaRebater: 'Decisão judicial',
  pecaRebaterHelper: 'Indique a decisão que contém vício a ser sanado',
  infoTip: 'Aponte especificamente a omissão, contradição ou obscuridade da decisão.',
};
export const EmbargosDeclaracaoCriminalForm = createFormFromConfig(EMBARGOS_DECLARACAO_CRIMINAL_CONFIG);

// Contrarrazões aos Embargos de Declaração Criminal
export const CONTRARRAZOES_EMBARGOS_DECLARACAO_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões aos Embargos de Declaração (Criminal)',
  description: 'Resposta aos embargos de declaração no processo criminal',
  suggestedDocs: 'Decisão judicial, Embargos de declaração e Processo na íntegra.',
  defaultPecaRebater: 'Embargos de Declaração',
  pecaRebaterHelper: 'Indique os embargos que deseja responder',
  infoTip: 'Demonstre que não há omissão, contradição ou obscuridade na decisão embargada.',
};
export const ContrarrazoesEmbargosDeclaracaoCriminalForm = createFormFromConfig(CONTRARRAZOES_EMBARGOS_DECLARACAO_CRIMINAL_CONFIG);

// Pedido de Restituição de Coisa Apreendida
export const RESTITUICAO_COISA_APREENDIDA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Restituição de Coisa Apreendida',
  description: 'Requerimento para restituição de bens apreendidos no processo criminal',
  suggestedDocs: 'Auto de apreensão e Decisão judicial.',
  defaultPecaRebater: 'Decisão Judicial',
  pecaRebaterHelper: 'Indique a decisão judicial sobre a apreensão',
  infoTip: 'Demonstre a propriedade do bem e que sua restituição não prejudica o processo.',
};
export const RestituicaoCoisaApreendidaForm = createFormFromConfig(RESTITUICAO_COISA_APREENDIDA_CONFIG);

// Petição de Incidente (Execução Penal)
export const PETICAO_INCIDENTE_EXECUCAO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Petição de Incidente (Execução Penal)',
  description: 'Petição incidental na fase de execução da pena',
  suggestedDocs: 'Decisão da execução penal e Processo na íntegra.',
  defaultPecaRebater: 'Decisão da Execução Penal',
  pecaRebaterHelper: 'Indique a decisão da execução penal',
  infoTip: 'Formule o pedido específico dentro da fase de execução penal.',
};
export const PeticaoIncidenteExecucaoForm = createFormFromConfig(PETICAO_INCIDENTE_EXECUCAO_CONFIG);

// Agravo em Execução Penal
export const AGRAVO_EXECUCAO_PENAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Agravo em Execução Penal',
  description: 'Recurso contra decisões do juízo da execução penal',
  suggestedDocs: 'Decisão da execução penal.',
  defaultPecaRebater: 'Decisão da Execução Penal',
  pecaRebaterHelper: 'Indique a decisão da execução penal que deseja agravar',
  infoTip: 'Demonstre o erro da decisão e as razões para sua reforma.',
};
export const AgravoExecucaoPenalForm = createFormFromConfig(AGRAVO_EXECUCAO_PENAL_CONFIG);

// Contrarrazões ao Agravo em Execução Penal
export const CONTRARRAZOES_AGRAVO_EXECUCAO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Agravo em Execução Penal',
  description: 'Resposta ao agravo interposto na execução penal',
  suggestedDocs: 'Agravo em execução penal, Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Agravo em Execução Penal',
  pecaRebaterHelper: 'Indique o agravo que deseja contrarrazoar',
  infoTip: 'Defenda a manutenção da decisão do juízo da execução.',
};
export const ContrarrazoesAgravoExecucaoForm = createFormFromConfig(CONTRARRAZOES_AGRAVO_EXECUCAO_CONFIG);

// Pedido de Livramento Condicional
export const LIVRAMENTO_CONDICIONAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Livramento Condicional',
  description: 'Requerimento de livramento condicional do apenado',
  suggestedDocs: 'Cálculo de pena, Certidões, Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Sentença Condenatória',
  pecaRebaterHelper: 'Indique a sentença condenatória',
  infoTip: 'Demonstre o cumprimento dos requisitos objetivos e subjetivos do art. 83 do CP.',
};
export const LivramentoCondicionalForm = createFormFromConfig(LIVRAMENTO_CONDICIONAL_CONFIG);

// Pedido de Indulto Natalino
export const INDULTO_NATALINO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Indulto Natalino',
  description: 'Requerimento de indulto com base em decreto presidencial',
  suggestedDocs: 'Atestado de Conduta, Processo na íntegra e Provas.',
  defaultPecaRebater: 'Processo inteiro',
  pecaRebaterHelper: 'Indique o processo penal completo',
  infoTip: 'Demonstre o enquadramento do apenado nos requisitos do decreto de indulto.',
};
export const IndultoNatalinoForm = createFormFromConfig(INDULTO_NATALINO_CONFIG);

// Peça a partir de Modelo Criminal
export const PECA_MODELO_CRIMINAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Peça a partir de Modelo (Criminal)',
  description: 'Adaptar modelo de peça criminal para novo caso',
  suggestedDocs: 'Modelo a ser adaptado e documentos do novo caso.',
  defaultPecaRebater: 'Modelo Original',
  pecaRebaterHelper: 'Faça upload do modelo que deseja adaptar',
  infoTip: 'A IA adaptará a estrutura e argumentos do modelo para os fatos do seu caso.',
};
export const PecaModeloCriminalForm = createFormFromConfig(PECA_MODELO_CRIMINAL_CONFIG);
